import { SVGProps } from 'react'

export const UserIcon = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				d="M11.9615 14.5C9.11657 14.5 6.12516 16.1427 4.51446 18.2744C4.1678 18.7332 3.99446 18.9626 4.00013 19.2726C4.00452 19.5121 4.15493 19.8143 4.34339 19.9622C4.58733 20.1536 4.92537 20.1536 5.60145 20.1536H18.3986C19.0746 20.1536 19.4127 20.1536 19.6566 19.9622C19.8451 19.8143 19.9955 19.5121 19.9999 19.2726C20.0055 18.9626 19.8322 18.7332 19.4856 18.2744C17.8749 16.1427 14.8064 14.5 11.9615 14.5Z"
				stroke="white"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.9615 12.0768C14.1918 12.0768 15.9999 10.2687 15.9999 8.0384C15.9999 5.80805 14.1918 4 11.9615 4C9.73112 4 7.92307 5.80805 7.92307 8.0384C7.92307 10.2687 9.73112 12.0768 11.9615 12.0768Z"
				stroke="white"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
